import moment from "moment";
import FFT from 'fft.js';

export const mdScreenWidth = 768

export const convertPhoneNumberInToMask = (num) => {
    var USNumber = num?.match(/(\d{3})(\d{3})(\d{4})/);
    if(USNumber){
      USNumber = "(" + USNumber[1] + ") " + USNumber[2] + "-" + USNumber[3];
      return USNumber;
    } else {
      return "";
    }
};

export const convertPhoneNumberFromMask = (maskedNumber) => {

  // Remove non-numeric characters using regular expression
  const cleanedNumber = maskedNumber.replace(/\D/g, "");
  
  return cleanedNumber;
}

export const imageFromUuid = (uuid) => {
  
  const authData = JSON.parse(localStorage.getItem('auth'));
  let url = '';

  let token = ''
  if(authData?.is_provider){
    token = '&token='+authData?.auth
  }
  else{
    token = '&na_auth='+authData?.auth
  }

  if(uuid){
    url = getBaseUrl().api_url + '/utilities/get_attachment.json?attachment='+ uuid +"&new_chat=1&tz="+ new Date().getTimezoneOffset()+token;
  }
  
  return url;
}

export const isPatientChatMessage = (msg) => {

  if(msg?.pid){
    return true
  }

  return false
}

export const padWithZero = (num) => (num < 10 ? `0${num}` : num);

export const isLoggedInUser = (authData, data) => {
  return (data?.nurse_id == authData?.id || data?.user_id == authData?.id)
}

export const printMessage = (data) => {
  
  const authData = JSON.parse(localStorage.getItem('auth'));
  let url = '';

  let token = ''
  if(authData?.is_provider){
    token = '&token='+authData?.auth
  }
  else{
    token = '&na_auth='+authData?.auth
  }
  if(data){
    url = getBaseUrl().api_url + '/nursing_home_chats/print?new_chat=1&tz='+ new Date().getTimezoneOffset()+token;
  }
  if(data?.pid){
    url = url + '&pid='+ data?.pid;
  }
  if(data?.location_id){
    url = url + '&location_id='+ data?.location_id;
  }
  if(data?.start_date){
    url = url + '&start_date='+ data?.start_date;
  }
  if(data?.end_date){
    url = url + '&end_date='+ data?.end_date;
  }
  if(data?.id){
    url = url + "&message_ids="+data.id;
  }
  
  return url;
}

export const concatAndRemoveDuplicates = (arr1, arr2) => {

  const uniqueRecords = {};

  if(!arr1){
    arr1 = []
  }
  if(!arr2){
    arr2 = []
  }

  const concatenatedArray = [...arr1, ...arr2].reduce((result, record) => {
    if (!uniqueRecords[record.id]) {
      result.push(record);
      uniqueRecords[record.id] = true;
    }
    return result;
  }, []);

  return concatenatedArray;
};


export const TimeAgo = ({ date, flow }) => {
  
  if(moment().diff(date, 'days') === 0) {
    return <span>{moment(date).format('hh:mm A')}</span>;
  } else if (moment().diff(date, 'days') === 1) {
    return <span>{flow == 'recent_chat' ? '' : 'Yesterday'} <span className="pl-1">{moment(date).format('hh:mm A')}</span></span>;
  } else {
    return <span>{flow == 'recent_chat' ? moment(date).format("MMM D") : moment(date).format("MMM D hh:mm A")}</span>;
  }
};

export const calculateAge = (dob) => {
  const currentDate = moment();
  return  currentDate.diff(dob, 'years');
}

export const setApiConfigFromUrl = () => {
 
  if(!getBaseUrl().api_url){
    const data = window.location.search.split('?data=')[1];
    const decodedData = decodeURIComponent(data);
    let parsedData = {}
    if(decodedData != 'undefined'){
      parsedData = JSON.parse(decodedData);
      localStorage.setItem('base_url', JSON.stringify(parsedData.organization_setting));
    }
  }
  
  return getBaseUrl().api_url
}


export const triggerTimerForPincodeScreen = () => {

  clearTimeout(window.pinTimeout);
  window.pinTimeout = setTimeout(() => {
    window.isPinCodeScreenActive = true;
    localStorage.setItem('isPinCodeScreenActive', true);
    const event = new Event("pinCodeScreenStatusChanged");
    window.dispatchEvent(event);
  }, 3600000);
}

export const setBaseUrl = (organizationCode = "") => {
  
  const organizationConfigurations = JSON.parse(localStorage.getItem('organization_config')) || [];
  const foundOrganizationSetting = organizationConfigurations.find((item)=>{
     return item?.short_code?.toUpperCase() == organizationCode?.toUpperCase()
  })
  let base_url = {};
  if(foundOrganizationSetting){
    base_url = foundOrganizationSetting
  }
  else{
    base_url = organizationConfigurations.find((item)=>{
      return !item.short_code;
    })
  }
  
  
  // base_url = {
  //   api_url: process.env.REACT_APP_API_URL_V1,
  //   pusher_settings:{
  //     pusher_key:  process.env.REACT_APP_PUSHER_ENV_KEY,
  //     pusher_env_key:  process.env.REACT_APP_PUSHER_ENV_CLUSTER
  //   }
  // }

  // if(organizationCode == 'hdc'){
  //   base_url = {
  //     base_api: process.env.REACT_APP_API_HDC_URL,
  //     pusher_key:  process.env.REACT_APP_HDC_PUSHER_ENV_KEY,
  //     pusher_env_key:  process.env.REACT_APP_HDC_PUSHER_ENV_CLUSTER
  //   }
  // }
  
  localStorage.setItem('base_url', JSON.stringify(base_url));
}

export const getBaseUrl = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const org = queryParams.get('org');
  let urlSettings = localStorage.getItem('base_url');
  urlSettings =  ["undefined", null].includes(urlSettings) ? null : JSON.parse(urlSettings);
  if(!urlSettings){
    urlSettings = {
      api_url: process.env.REACT_APP_API_URL_V1,
      pusher_settings:{
        key:  process.env.REACT_APP_PUSHER_ENV_KEY,
        cluster:  process.env.REACT_APP_PUSHER_ENV_CLUSTER
      },
      telemed_url: process.env.REACT_APP_PUSHER_ENV_TELEMED
    }
  }
  if (org && org?.toLowerCase()?.trim()){
    let newOrg = org?.toLowerCase()?.trim()
    urlSettings.api_url= `https://api-${newOrg}.ethizo.com`
  }
  // if (org=="hdc"){
  //   urlSettings.api_url = "https://api-hdc.ethizo.com"
  // }
  // else if (org=="ora1"){
  //   urlSettings.api_url = "https://api-ora1.ethizo.com"
  // }
  return urlSettings
}

const nurseUrgentMsg = {
  maltc: "This chat is not monitored. Please call our office at 757-354-2885 to speak with a MALTC representative.",
  default_msg:"For urgent messages, please call the provider directly via phone. For non-urgent messages, if you don't receive call back within a reasonable time, please call via phone."
}

export const getNurseUrgentMsg = () => {
  const region = getBaseUrl()?.short_code?.toLowerCase();
  return nurseUrgentMsg[region] || nurseUrgentMsg.default_msg;
}

export const titleWithoutUnderscore = (title) => {
  if(!title) return;
  return title.replace(/_/g, ' ');
}

// Convert HTML tags to plain text
export const removeHtmlTags = (htmlText) => {
  return htmlText.replace(/<br\s*\/?>/g, "\n").replace(/<\/?[^>]+(>|$)/g, ""); // Remove all HTML tags and convert <br> tags into new lines
}

export const ProcessedMessageWithTags = (messageText) => {
  const tagPattern = /@\[[^\]]+\]/g;
  const tags = messageText.match(tagPattern) || [];
  const splitMessageParts = messageText.split(tagPattern);
  
  const processedMessage = splitMessageParts.flatMap((part, index) => {
      const elements = [part];

      // Check for line breaks and add <br /> where necessary
      if (part.includes('\n')) {
          const lines = part.split('\n');
          const lineElements = lines.flatMap((line, lineIndex) => {
              return [
                  line, // The line text
                  lineIndex < lines.length - 1 ? <br key={`br-${index}-${lineIndex}`} /> : null // Add <br /> except for the last line
              ];
          });
          elements.splice(elements.length - 1, 1, ...lineElements); // Replace the part with line elements
      }

      if (tags[index]) {
          const tag = tags[index]?.replace(/@\[|\]/g, '');

          elements.push(
              <span key={index} className="mention-box">
                  {tag}
              </span>
          );
      }
      return elements;
  });
  return processedMessage;
}


export const highlightMentionText = (text) => {
  const mentionRegex = /\@\[([^\]]+)\]/g;

  return text.replace(mentionRegex, (match, name) => {
    return `<span class="bg-blue-300 rounded-md p-1">${name}</span>`;
  });
}

export const detectHumanVoice = async(audioBlob) => {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  const decodedData = await audioContext.decodeAudioData(await audioBlob.arrayBuffer());
  
  // Analyze the audio buffer to detect human voice
  const hasVoice = analyzeAudio(decodedData);

  // Output the result
  console.log('Human voice detected:', hasVoice);
}

const analyzeAudio = (decodedData) => {

  const numChannels = decodedData.numberOfChannels;
  const sampleRate = nextPowerOfTwo(decodedData.sampleRate);
  const channelData = []; // Array to store audio data for each channel
  
  // Extract audio data from each channel
  for (let i = 0; i < numChannels; i++) {
    channelData.push(decodedData.getChannelData(i));
  }
  
  // Analyze audio data for human voice
  for (let i = 0; i < channelData.length; i++) {
    const data = channelData[i];

    // Calculate average energy level
    const energy = calculateEnergy(data);

    // Check for vocal frequencies
    const hasVocalFrequencies = detectVocalFrequencies(data, sampleRate);

    // Example: Check for speech activity using amplitude thresholding
    const speechActivity = detectSpeechActivity(data);
    const thresholdEnergy = 0.1;

    // Combine different metrics to determine if human voice is present
    const hasVoice = energy > thresholdEnergy && hasVocalFrequencies && speechActivity;

    if(hasVoice){
      return true; // Human voice detected
    }
  }
  
  return false; // No human voice detected
}
  
function calculateEnergy(data) {
  // Calculate energy as the sum of squared values
  return data.reduce((total, sample) => total + sample * sample, 0);
}

function detectVocalFrequencies(data, sampleRate) {
  const fft = new FFT(sampleRate);
  // const input = new Array(sampleRate);
  // input.fill(0);

  // const out = fft.createComplexArray();
  // fft.realTransform(out, data);
  
  const spectrum = fft.createComplexArray(); // Create an array to store the FFT results
  fft.simple(spectrum, data, 'real');

  // Detect vocal frequencies for human voice range (e.g., 80Hz - 300Hz)
  const binWidth = (sampleRate / data.length)
  const vocalRangeStart = Math.round(80 / binWidth);
  const vocalRangeEnd = Math.round(300 / binWidth);

  // Sum magnitudes of frequency components in the vocal range
  let vocalEnergy = 0;
  for (let i = vocalRangeStart; i <= vocalRangeEnd; i++) {
    // vocalEnergy += Math.pow(fft[i], 2);
    const amplitude = Math.sqrt(spectrum[i * 2] ** 2 + spectrum[i * 2 + 1] ** 2); // Calculate amplitude
    vocalEnergy += amplitude * amplitude;
  }

  // Threshold for detecting vocal frequencies
  const threshold = 1000;

  return vocalEnergy > threshold;


    // Perform FFT on decoded audio data
    // const fft = new FFT(sampleRate);
    // fft.transform(sampleRate, data);

    // // Identify fundamental frequency (F0)
    // const frequencyResolution = sampleRate / data.length;
    // let maxAmplitude = 0;
    // let maxFrequencyIndex = 0;

    // for (let i = 0; i < fft.spectrum.length; i++) {
    //   const amplitude = fft.spectrum[i];
    //   if (amplitude > maxAmplitude) {
    //     maxAmplitude = amplitude;
    //     maxFrequencyIndex = i;
    //   }
    // }

    // // Calculate vocal frequency (fundamental frequency)
    // const vocalFrequency = maxFrequencyIndex * frequencyResolution;

    // console.log('Vocal Frequency:', vocalFrequency, 'Hz');

}


function detectSpeechActivity(data){

  // Calculate the average amplitude of the audio signal
  const averageAmplitude = data.reduce((total, sample) => total + Math.abs(sample), 0) / data.length;

  // Threshold for detecting speech activity
  const threshold = 0.1;

  return averageAmplitude > threshold;
}

function nextPowerOfTwo(size) {
  let power = 1;
  while (power < size) {
    power *= 2;
  }
  return power;
}

export const sessionDuration = [
  {value: 5, label: '5 Mins'},
  {value: 10, label: '10 Mins'},
  {value: 15, label: '15 Mins'},
  {value: 20, label: '20 Mins'},
  {value: 30, label: '30 Mins'},
  {value: 40, label: '40 Mins'},
  {value: 45, label: '45 Mins'},
  {value: 60, label: '60 Mins'},
  {value: 90, label: '90 Mins'},
  {value: 120, label: '120 Mins'},
  {value: 150, label: '150 Mins'},
  {value: 180, label: '180 Mins'},
  {value: 210, label: '210 Mins'},
  {value: 240, label: '240 Mins'},
  {value: 270, label: '270 Mins'},
  {value: 300, label: '300 Mins'},
  {value: 330, label: '330 Mins'},
  {value: 360, label: '360 Mins'}
]

// Browser Notification Utilities
export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    console.log("This browser does not support desktop notification");
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  if (Notification.permission !== "denied") {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  }

  return false;
}

export const showBrowserNotification = (title, options = {}) => {
  if (!("Notification" in window)) {
    console.warn("This browser does not support desktop notification");
    return;
  }

  if (Notification.permission === "granted") {
     if("serviceWorker" in navigator) {
        navigator.serviceWorker.ready
          .then((registration) => {
            const notificationOptions = {
              icon: options.icon || "/favicon.ico",
              badge: options.badge || "/favicon.ico",
              body: options.body || "",
              tag: options.tag || "nursing-chat-message",
              requireInteraction: options.requireInteraction || false,
            };
            return registration.showNotification(title, notificationOptions);
          })
      }
  } else if (Notification.permission !== "denied") {
    requestNotificationPermission().then((granted) => {
      if(granted) showBrowserNotification(title, options);
    });
  }
  return null;
};